/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './birth-history.reducer';

export const BirthHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const birthHistoryEntity = useAppSelector(state => state.birthHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="birthHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.birthHistory.detail.title">BirthHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.birthHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.id}</dd>
          <dt>
            <span id="gestation">
              <Translate contentKey="tinyMedicRestApp.birthHistory.gestation">Gestation</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.gestation}</dd>
          <dt>
            <span id="delivery">
              <Translate contentKey="tinyMedicRestApp.birthHistory.delivery">Delivery</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.delivery}</dd>
          <dt>
            <span id="birthWeight">
              <Translate contentKey="tinyMedicRestApp.birthHistory.birthWeight">Birth Weight</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.birthWeight}</dd>
          <dt>
            <span id="birthHeight">
              <Translate contentKey="tinyMedicRestApp.birthHistory.birthHeight">Birth Height</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.birthHeight}</dd>
          <dt>
            <span id="breastFed">
              <Translate contentKey="tinyMedicRestApp.birthHistory.breastFed">Breast Fed</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.breastFed ? 'true' : 'false'}</dd>
          <dt>
            <span id="twins">
              <Translate contentKey="tinyMedicRestApp.birthHistory.twins">Twins</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.twins ? 'true' : 'false'}</dd>
          <dt>
            <span id="birthOrder">
              <Translate contentKey="tinyMedicRestApp.birthHistory.birthOrder">Birth Order</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.birthOrder}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.birthHistory.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.notes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.birthHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.birthHistory.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.birthHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.birthHistory.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.birthHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.birthHistory.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{birthHistoryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.birthHistory.pregnancy">Pregnancy</Translate>
          </dt>
          <dd>{birthHistoryEntity.pregnancy ? birthHistoryEntity.pregnancy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.birthHistory.recordedBy">Recorded By</Translate>
          </dt>
          <dd>{birthHistoryEntity.recordedBy ? birthHistoryEntity.recordedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.birthHistory.recordedAt">Recorded At</Translate>
          </dt>
          <dd>{birthHistoryEntity.recordedAt ? birthHistoryEntity.recordedAt.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.birthHistory.vitals">Vitals</Translate>
          </dt>
          <dd>{birthHistoryEntity.vitals ? birthHistoryEntity.vitals.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.birthHistory.patient">Patient</Translate>
          </dt>
          <dd>{birthHistoryEntity.patient ? birthHistoryEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.birthHistory.mother">Mother</Translate>
          </dt>
          <dd>{birthHistoryEntity.mother ? birthHistoryEntity.mother.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.birthHistory.father">Father</Translate>
          </dt>
          <dd>{birthHistoryEntity.father ? birthHistoryEntity.father.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/birth-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/birth-history/${birthHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BirthHistoryDetail;
